import React from 'react';
import Parent from '../parent';
import { withTranslation } from 'react-i18next';

import { constants } from '../constants/constants';
import DebtPaymentsSection from '../../common/payment_flow/debtPaymentsSection';
import OnGoingPaymentSection from '../../common/payment_flow/onGoingPaymentSection';
import OneTimePaymentSection from '../../common/payment_flow/oneTimePaymentSection';
import {BllinkLogger} from '../utils/bllink_loggers';
import CacheData from '../utils/cacheData';
import './paymentMiddleContent.css';
import ChequeForm from "./chequeForm";
import ChequeDepositForm from './ChequeDepositForm';

export class PaymentMiddleContent extends Parent {

    loadingStarted = false;

    constructor(props) {
        super(props);
        this.newState.bind(this);
        this.defaultTab = constants.pages.debtTab;
        BllinkLogger.info('PaymentMiddleContent called with ', props);
        this.state = this.newState(props);
    }

    componentDidUpdate(prevProps) {
        if (this.props !== prevProps) {
            BllinkLogger.info('PaymentMiddleContent componentDidUpdate called with ', this.props);
            this.setState(this.newState(this.props));
        }
    }

    selectRightTab(props){
        const paymentsStats = props.paymentsStats;
        if (props.paymentTabSelected === constants.pages.chequeTab){
            return constants.pages.chequeTab
        }

        if (props.paymentTabSelected === constants.pages.chequeDepositTab) {
            return constants.pages.chequeDepositTab
        }

        const hasExactlyOnePaymentTabActive = (paymentsStats && paymentsStats.nonEmptyPayments === 1);
        if (hasExactlyOnePaymentTabActive){
            if (!paymentsStats.debtIsEmpty){
                return constants.pages.debtTab
            }
            if (!paymentsStats.monthlyIsEmpty){
                return constants.pages.onGoingTab
            }
            if (!paymentsStats.oneTimeIsEmpty){
                return constants.pages.oneTimeTab
            }
        }
    }

    hasOpenOneTimePayments(props){
        return (props?.paymentsData?.one_time_payments && props.paymentsData.one_time_payments.length > 0)
    }

    newState(props){
        const rightTab = this.selectRightTab(props) || props.paymentTabSelected || this.defaultTab;
        //https://app.asana.com/0/1123966772501425/1199546685691687
        // enable offline payments for future months (not just the next month)
        const shouldHideCreditCardOption = (props.paymentsData &&
                props.paymentsData.on_going_payments &&
                props.paymentsData.on_going_payments.notValidForCreditCardPayment
        )
        BllinkLogger.info(`right tab ${rightTab}`);
        this.setVisitedTab(rightTab);
        return {
            paymentTabSelected: rightTab,
            paymentsData: props.paymentsData,
            shouldHideCreditCardOption: shouldHideCreditCardOption,
            finishedLoadDataFromBackend: props.finishedLoadDataFromBackend
        }

    }

    setVisitedTab(paymentTabSelected){
        // will mark the visited tab with v to notate the user that it's visited
        const visited = CacheData.fetchCache('visitedTabs') || {};
        visited[paymentTabSelected] = true;
        CacheData.cache('visitedTabs', visited);
    }


    render() {

        const paymentsData = this.state.paymentsData || {};
        const paymentTabSelected = this.state.paymentTabSelected;
        const hasOpenOneTimePayments = this.hasOpenOneTimePayments(this.props)

        BllinkLogger.info(`paymentTabSelected final is ${paymentTabSelected}`)
        BllinkLogger.info(`this props PaymentMiddleContent`, this.props);

        if (!this.state.finishedLoadDataFromBackend){
            //https://app.asana.com/0/1196545425570329/1198956650306898
            // Should show loader instead of text when changing tabs or refreshing the page
            if (!this.loadingStarted) {
                this.loadingStarted = true;
                this.startLoader();
            }
            return (
                <div className="container p-dept-section loading-content">
                    {/*<h2>{t('titles.loading')}</h2>*/}
                </div>)
        }
        if (this.loadingStarted) {
            this.loadingStarted = false;
            this.endLoader();
        }

        switch (paymentTabSelected) {
            case constants.pages.debtTab:
                return (
                    <DebtPaymentsSection
                        payments={paymentsData.past_payments}
                        paymentsStats={this.props.paymentsStats}
                        buildingID={this.props.buildingID}
                        apartmentNumber={this.props.apartmentNumber}
                        onChangeNextBack={this.props.onNextBackChange}
                        isViewedAsManager={this.props.isViewedAsManager}
                        shouldHideCreditCardOption={this.state.shouldHideCreditCardOption}
                        hasOpenOneTimePayment={hasOpenOneTimePayments}
                    />
                )
            case constants.pages.onGoingTab:
                return (
                    <OnGoingPaymentSection
                        buildingData={this.props.buildingData}
                        payments={paymentsData.on_going_payments}
                        paymentsStats={this.props.paymentsStats}
                        buildingID={this.props.buildingID}
                        apartmentNumber={this.props.apartmentNumber}
                        onChangeNextBack={this.props.onNextBackChange}
                        isViewedAsManager={this.props.isViewedAsManager}
                        shouldHideCreditCardOption={this.state.shouldHideCreditCardOption}
                        hasOpenOneTimePayment={hasOpenOneTimePayments}
                    />
                )
            case constants.pages.oneTimeTab:
                return (
                    <OneTimePaymentSection
                        payments={paymentsData.one_time_payments}
                        paymentsStats={this.props.paymentsStats}
                        buildingID={this.props.buildingID}
                        apartmentNumber={this.props.apartmentNumber}
                        onChangeNextBack={this.props.onNextBackChange}
                        isViewedAsManager={this.props.isViewedAsManager}
                        shouldHideCreditCardOption={this.state.shouldHideCreditCardOption}
                    />
                )

            case constants.pages.chequeTab:
                return (
                    <ChequeForm
                        amount={this.calcTotalToPayFromSelected({buildingID: this.props.buildingID, apartmentNumber: this.props.apartmentNumber})}
                        buildingID={this.props.buildingID}
                        apartmentNumber={this.props.apartmentNumber}
                    />
                );

            case constants.pages.chequeDepositTab:
                return (
                    <ChequeDepositForm
                        amount={this.calcTotalToPayFromSelected({buildingID: this.props.buildingID, apartmentNumber: this.props.apartmentNumber})}
                        buildingID={this.props.buildingID}
                        apartmentNumber={this.props.apartmentNumber}
                    />
                );

            default:
                BllinkLogger.warn(`default payments tab selected`);
                return (
                    <DebtPaymentsSection
                        payments={paymentsData.past_payments}
                        paymentsStats={this.props.paymentsStats}
                        buildingID={this.props.buildingID}
                        apartmentNumber={this.props.apartmentNumber}
                        onChangeNextBack={this.props.onNextBackChange}
                        isViewedAsManager={this.props.isViewedAsManager}
                        shouldHideCreditCardOption={this.state.shouldHideCreditCardOption}
                        hasOpenOneTimePayment={hasOpenOneTimePayments}
                    />
                    )
        }

    }
}


export default withTranslation()(PaymentMiddleContent);
